import { Box, Typography } from '@mui/material';

import { TitleBulletListTextContent } from './components';
import {
  isNestedTitleBulletListItem,
  isStyledTitleBulletListSubtitle,
  mergeSxProps,
} from './utils';

import type { TitleBulletListProps } from './types';

export default function TitleBulletList({
  title,
  subtitles,
  summary,
  items,
  sx,
}: TitleBulletListProps) {
  return (
    <Box sx={mergeSxProps({ textAlign: 'left', mb: 3 }, sx)}>
      <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
        {title}
      </Typography>
      {subtitles?.map((subtitle, index) => {
        const isStyledSubtitle = isStyledTitleBulletListSubtitle(subtitle);

        return (
          <Typography
            key={index}
            variant="body1"
            sx={mergeSxProps(
              isStyledSubtitle ? {} : { mb: 1 },
              isStyledSubtitle ? subtitle.styles : undefined,
            )}
          >
            {isStyledSubtitle ? (
              <TitleBulletListTextContent content={subtitle} />
            ) : (
              subtitle
            )}
          </Typography>
        );
      })}
      {items && (
        <Box component="ul" sx={{ pl: 3, m: 0, listStyleType: 'disc' }}>
          {items.map((item, index) =>
            isNestedTitleBulletListItem(item) ? (
              <Box component="li" key={index}>
                <Typography variant="body1">
                  <TitleBulletListTextContent content={item.title} />
                </Typography>
                <Box component="ul" sx={{ pl: 3, m: 0, listStyleType: 'disc' }}>
                  {item.items.map((nestedItem, nestedIndex) => (
                    <Typography component="li" key={`${index}-${nestedIndex}`} variant="body1">
                      <TitleBulletListTextContent content={nestedItem} />
                    </Typography>
                  ))}
                </Box>
              </Box>
            ) : (
              <Typography component="li" key={index} variant="body1">
                <TitleBulletListTextContent content={item} />
              </Typography>
            ),
          )}
        </Box>
      )}
      {summary?.map((item, index) => {
        const isStyledSummaryItem = isStyledTitleBulletListSubtitle(item);

        return (
          <Typography
            key={index}
            variant="body1"
            sx={mergeSxProps(
              { mt: 1 },
              isStyledSummaryItem ? item.styles : undefined,
            )}
          >
            {isStyledSummaryItem ? (
              <TitleBulletListTextContent content={item} />
            ) : (
              item
            )}
          </Typography>
        );
      })}
    </Box>
  );
}
